import React, { useState } from "react";

export default function Paso4Confirmacion({ leadData, resultados, onReiniciar, onConfirmar }) {
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const datos = resultados?.datos_extraidos || {};
  const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

  const handleEnviar = async () => {
    if (enviando || enviado) return;
    setEnviando(true);
    try {
      const formData = new FormData();
      formData.append("lead_id", String(leadData.lead_id));
      await fetch(`${API}/api/solicitud`, { method: "POST", body: formData });
    } catch (e) {
      console.error(e);
    } finally {
      setEnviando(false);
      setEnviado(true);
      if (onConfirmar) onConfirmar();
    }
  };

  // ── ÉXITO ──
  if (enviado) {
    return (
      <div style={{ textAlign: "center", padding: "40px 0" }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
        <h2 style={{
          fontFamily: "var(--display)", fontSize: "clamp(22px, 4vw, 34px)",
          fontWeight: 800, letterSpacing: "-0.02em", marginBottom: 16,
        }}>
          ¡Solicitud enviada!
        </h2>
        <div style={{
          background: "rgba(0,229,160,.07)", border: "1px solid rgba(0,229,160,.25)",
          borderRadius: 14, padding: "28px 32px", maxWidth: 520, margin: "0 auto 32px",
        }}>
          <p style={{ fontSize: 16, lineHeight: 1.8, color: "var(--text2)" }}>
            Gracias por utilizar el comparador energético de{" "}
            <strong style={{ color: "var(--text)" }}>Nerón Energía</strong>.<br /><br />
            En breve, nuestro departamento de ingeniería se pondrá en contacto contigo
            para ayudarte a elegir la mejor opción y gestionar el cambio de tarifa
            sin ningún coste ni complicación.
          </p>
        </div>
        <button className="btn btn-primary" onClick={onReiniciar} style={{ maxWidth: 320, margin: "0 auto" }}>
          ↩ Realizar otra comparativa
        </button>
      </div>
    );
  }

  // ── CONFIRMACIÓN ──
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <h2 style={{
          fontFamily: "var(--display)", fontSize: "clamp(22px, 4vw, 34px)",
          fontWeight: 800, letterSpacing: "-0.02em", marginBottom: 12,
        }}>
          Resumen de tu solicitud
        </h2>
        <p style={{ color: "var(--text2)", fontSize: 15, maxWidth: 500, margin: "0 auto", lineHeight: 1.7 }}>
          Estos son tus datos. Si quieres ser asesorado por{" "}
          <strong style={{ color: "var(--text)" }}>Nerón Energía</strong>, pulsa{" "}
          <em>Enviar solicitud</em> y nos pondremos en contacto contigo a la mayor brevedad.
        </p>
      </div>

      <div className="card">
        <div className="card-title">Tus datos de contacto</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <DatoItem label="Nombre" valor={leadData?.nombre} />
          <DatoItem label="Teléfono" valor={leadData?.telefono} />
          <DatoItem label="Email" valor={leadData?.email} full />
        </div>
      </div>

      <div className="card">
        <div className="card-title">Datos de tu factura</div>
        <div className="factura-resumen">
          {datos.cups        && <DatoItem label="CUPS"            valor={datos.cups} full />}
          {datos.potencia    != null && <DatoItem label="Potencia"        valor={`${datos.potencia} kW`} />}
          {datos.dias        != null && <DatoItem label="Días facturados"  valor={datos.dias} />}
          {datos.p1_kwh      != null && <DatoItem label="P1 Punta"        valor={`${datos.p1_kwh} kWh`} />}
          {datos.p2_kwh      != null && <DatoItem label="P2 Llano"        valor={`${datos.p2_kwh} kWh`} />}
          {datos.p3_kwh      != null && <DatoItem label="P3 Valle"        valor={`${datos.p3_kwh} kWh`} />}
          {datos.consumo     != null && <DatoItem label="Consumo total"   valor={`${datos.consumo} kWh`} />}
          {datos.importe     != null && <DatoItem label="Importe actual"  valor={`${datos.importe} €`} accent />}
        </div>
      </div>

      <button className="btn btn-primary" onClick={handleEnviar} disabled={enviando} style={{ marginTop: 8 }}>
        {enviando ? "Enviando..." : "📩 Enviar solicitud"}
      </button>

      <button className="btn btn-secondary" onClick={onReiniciar} style={{ marginTop: 10 }}>
        ← Volver al comparador
      </button>
    </div>
  );
}

function DatoItem({ label, valor, accent, full }) {
  return (
    <div className="fr-item" style={full ? { gridColumn: "1 / -1" } : {}}>
      <div className="fr-label">{label}</div>
      <div className={`fr-val${accent ? " accent" : ""}`} style={{ fontSize: 14 }}>{valor || "—"}</div>
    </div>
  );
}
